// NPM
import React, { PureComponent } from 'react';
import HiddenTag from './Tags/HiddenTag';
import { isEmpty, capitalize } from 'lodash';

import { ListPartitioner } from 'frontend-component-library';
import { getTagCategory } from 'services/tagDisplayCategoriesService';

class HiddenTagsList extends PureComponent {
  getTagCategory = hiddenTag => getTagCategory(hiddenTag.tagSchema);

  renderHiddenTag = hiddenTag => {
    return (
      <li className="HiddenTagsList-tag-container" key={hiddenTag.id}>
        <HiddenTag hiddenTag={hiddenTag} />
      </li>
    );
  };

  renderCategory = (category, hiddenTags) => {
    if (hiddenTags.length === 0) {
      return null;
    }

    return (
      <li key={category} className="HiddenTagsList-tags">
        <h2 className="HiddenTagsList-heading">{capitalize(category)}</h2>
        <ul>{hiddenTags.map(this.renderHiddenTag)}</ul>
      </li>
    );
  };

  render() {
    const { hiddenTags } = this.props;
    if (isEmpty(hiddenTags)) {
      return null;
    }

    return (
      <ul className="HiddenTagsList">
        <ListPartitioner
          items={hiddenTags}
          splitter={this.getTagCategory}
          categoryRendererCallback={this.renderCategory}
        />
      </ul>
    );
  }
}

export default HiddenTagsList;



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/HiddenTagsList.js